import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
import moment from 'moment';

// Reducer Thunk
export const getCompanySaleOderDetails = createAsyncThunk('CompanySaleOderDetails/todosFetched', async (loadData) => {
    try {
        let response
        let docList
        response = await axios.create(axiosConfig).post(`api/report/CompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

export const getSalesByEmployeeGroupByDate = createAsyncThunk('CompanySaleOderDetails/SalesByEmployeeGroupByDate', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/CompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

const CompanySaleOderDetailsSlice = createSlice({
    name: 'CompanySaleOderDetails',
    initialState: {
        allPageLoad: [],
        SalesGroupByDate: [],
        TotalBPOder: 0,
        TotalDelivery: 0,
        TotalQty: 0,
        TotalTurnover: 0,
        Loading: true,
        SalesByEmployee: [],
        QtyByPro2: [],
        Top5QtyByPro4: [],
        energySources: [],
        SalesByEmployeeGroupByDate: []

    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getSalesByEmployeeGroupByDate.fulfilled, (state, action) => {

            state.SalesByEmployeeGroupByDate = action.payload
            let resultEnergySources = [];
            if (action.payload.length > 0) {
                resultEnergySources = action.payload[0].SlpNameSplit.length > 1 ?action.payload[0].SlpNameSplit.split(","):[];
            }
            state.energySources = resultEnergySources
        })
        builder.addCase(getCompanySaleOderDetails.pending, (state, action) => {
            state.Loading = true
        })
        builder.addCase(getCompanySaleOderDetails.fulfilled, (state, action) => {
            state.allPageLoad = action.payload
            let result = [];
            if (action.payload.length > 0) {
                ///
                //sum doanh thu theo NVKD
                (action.payload).reduce(function (res, value) {
                    if (!res[value.SlpName + value.DocDate]) {
                        res[value.SlpName + value.DocDate] = { SlpName: value.SlpName, DocDate: value.DocDate, GTotal: 0 };
                        result.push(res[value.SlpName + value.DocDate])
                    }
                    res[value.SlpName + value.DocDate].GTotal += value.GTotal;
                    return res;
                }, {});
                //Sắp sếp ngày tăng dần
                var sortByDocDateSalesEmployee = result.sort(function (a, b) {
                    return new Date(a.DocDate) - new Date(b.DocDate);
                });

                //Sắp xếp từ lớn tới nhỏ
                var sortByGTotal = result.sort(function (a, b) {
                    return b.GTotal - a.GTotal;
                });
                //Lấy top 10 NVKD có doanh thu cao nhất
                var topTen = sortByGTotal.slice(0, 10);

                state.SalesByEmployee = topTen
                ///
                //Sum Doanh thu theo ngày
                const GroupByDocDate = [];
                if (action.payload.length > 0) {
                    if (action.payload[0].TimeType === 'year') {
                        (action.payload).reduce(function (res, value) {
                            const DateCol = new Date(value.DocDate).getMonth() + 1
                            if (!res[DateCol]) {
                                res[DateCol] = { DocDate: DateCol, DateFormat: ('00' + DateCol).substring(DateCol.toString().length === 1 ? 1 : 2), val: 0 };
                                GroupByDocDate.push(res[DateCol])
                            }
                            res[DateCol].val += value.GTotal;
                            return res;
                        }, {});

                    }
                    else if (action.payload[0].TimeType === 'quarter') {
                        (action.payload).reduce(function (res, value) {

                            const DateCol = moment(value.DocDate).week()
                            if (!res[DateCol]) {
                                res[DateCol] = { DocDate: DateCol, DateToolTip: 'Tuần ' + DateCol + ' ' + moment(value.DocDate).startOf('week').format('DD/MM') + '-' + moment(value.DocDate).endOf('week').format('DD/MM'), DateFormat: ('00' + DateCol).substring(DateCol.toString().length === 1 ? 1 : 2), val: 0 };
                                GroupByDocDate.push(res[DateCol])
                            }
                            res[DateCol].val += value.GTotal;
                            return res;
                        }, {});
                    }   
                    else {
                        (action.payload).reduce(function (res, value) {
                            if (!res[value.DocDate]) {
                                res[value.DocDate] = { DocDate: value.DocDate, DateFormat: new Date(value.DocDate).getDate() + "-" + (new Date(value.DocDate).getMonth() + 1), val: 0 };
                                GroupByDocDate.push(res[value.DocDate])
                            }
                            res[value.DocDate].val += value.GTotal;
                            return res;
                        }, {});
                    }
                }


                //Sắp sếp ngày tăng dần
                var sortByDocDate = GroupByDocDate.sort(function (a, b) {
                    return new Date(a.DocDate) - new Date(b.DocDate);
                });
                state.SalesGroupByDate = sortByDocDate

                //Sum sản lượng theo loại giấy
                let QtyByPro2 = [];
                (action.payload).reduce(function (res, value) {
                    if (value.U_Pro_2 !== 'Phí gia công') {
                        if (!res[value.U_Pro_2]) {
                            {
                                res[value.U_Pro_2] = { U_Pro_2: value.U_Pro_2, val: 0 };
                                QtyByPro2.push(res[value.U_Pro_2])
                            }
                        }
                        res[value.U_Pro_2].val += value.InvQty;
                    }
                    return res;
                }, {});
                state.QtyByPro2 = QtyByPro2

                let counter = 0
                //Tổng sản lượng
                state.TotalQty = (action.payload).reduce((res, value) => counter += value.InvQty, 0)

                //Sum sản lượng theo nhãn hàng
                let QtyByPro4 = [];
                (action.payload).reduce(function (res, value) {
                    if (!res[value.U_Pro_4]) {
                        res[value.U_Pro_4] = { U_Pro_4: value.U_Pro_4, Percent: 0, val: 0 };
                        QtyByPro4.push(res[value.U_Pro_4])
                    }
                    res[value.U_Pro_4].val += value.InvQty;
                    res[value.U_Pro_4].Percent += (value.InvQty / counter * 100);
                    return res;
                }, {});

                //Sắp xếp theo sản lượng giảm dần
                var sortByQtyByPro4 = QtyByPro4.sort(function (a, b) {
                    return b.val - a.val;
                });
                //Lấy top 5 nhãn hàng có sản lượng cao nhất
                var topFive = sortByQtyByPro4.slice(0, 5);
                state.Top5QtyByPro4 = topFive

                counter = 0
                //Đếm tổng số đơn hàng
                let resultTotalDeliveryGroup = []
                const TotalDeliveryGroup = (action.payload).reduce(function (res, value) {
                    if (!res[value.U_S1No]) {
                        res[value.U_S1No] = { U_S1No: value.U_S1No, Count: 0 };
                        resultTotalDeliveryGroup.push(res[value.U_S1No])
                        counter += 1;
                    }
                    res[value.U_S1No].Count += 1;
                    return res;
                }, {});
                state.TotalDelivery = counter

                counter = 0
                //Đếm tổng số khách hàng
                let resultTotalBPOderGroup = []
                const TotalBPOderGroup = (action.payload).reduce(function (res, value) {
                    if (!res[value.CardName]) {
                        res[value.CardName] = { CardName: value.CardName, Count: 0 };
                        resultTotalBPOderGroup.push(res[value.CardName])
                        counter += 1;
                    }
                    res[value.CardName].Count += 1;
                    return res;
                }, {});
                state.TotalBPOder = counter

                counter = 0
                //Tổng doanh thu
                state.TotalTurnover = (action.payload).reduce((res, value) => counter += value.GTotal, 0)
            }
            else {
                state.SalesByEmployee = []
                state.Top5QtyByPro4 = []
                state.QtyByPro2 = []
                state.SalesGroupByDate = []
                state.TotalBPOder = 0
                state.TotalDelivery = 0
                state.TotalTurnover = 0
                state.TotalQty = 0
            }

            state.Loading = false
        })
        builder.addCase(getCompanySaleOderDetails.rejected, (state, action) => {
            state.Loading = false
        })
    }
})

// Reducer
const CompanySaleOderDetailsReducer = CompanySaleOderDetailsSlice.reducer

// Selector
export const CompanySaleOderDetailsSelector = (state) => state.CompanySaleOderDetailsReducer
// Action export
export const {
} = CompanySaleOderDetailsSlice.actions

// Export reducer
export default CompanySaleOderDetailsReducer